
export class RenderRetryManager {
  private renderAttempts: number = 0;
  private maxRenderAttempts: number = 5;
  private renderTimeout: number | null = null;
  
  get attempts(): number {
    return this.renderAttempts;
  }
  
  incrementAttempts(): void {
    this.renderAttempts++;
  }
  
  resetAttempts(): void {
    this.renderAttempts = 0;
  }
  
  hasExceededMaxAttempts(): boolean {
    return this.renderAttempts >= this.maxRenderAttempts;
  }
  
  scheduleRetry(callback: () => void, delay: number = 500): void {
    console.log(`[DEBUG] Scheduling retry attempt in ${delay}ms (attempt ${this.renderAttempts}/${this.maxRenderAttempts})`);
    if (this.renderTimeout !== null) {
      clearTimeout(this.renderTimeout);
    }
    this.renderTimeout = window.setTimeout(callback, delay);
  }
  
  cleanup(): void {
    if (this.renderTimeout !== null) {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = null;
    }
  }
}
